module.exports = __webpack_public_path__ + "images/icon_question_circle_blue.svg";